import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { EditEmployeeAccess } from "modules/settings/components/Team/EditEmployeeAccess"

export const Route = createFileRoute("/_base/_auth/settings/team/$employeeId/access")({
  component: RouteComponent,
})

function RouteComponent() {
  const { employeeId } = Route.useParams()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/settings/team" })
  }

  return <EditEmployeeAccess employeeId={employeeId} onClose={onClose} />
}
